import React from "react";

import loginCss from "../../css/login/login.css";

export default class Praxy extends React.Component{ 
   constructor(props){ 
      super(props); 
      this.state = {
         cid: '',
         password: '',
         cfAzienda:'',
         ruolo:'',
         showSuccess:false,
         showError:false,
         errorMessage:"",
         successMessage:""
       }
       sessionStorage.clear();
   }


   render(){ 
      return(
         <div className="container" style={{marginTop:"100px", minHeight:"70vh"}}>
             <br/>
            <div className="row">
           <h1> I dati personali forniti sono trattati da Nordcom S.p.A., in qualità di responsabile del trattamento nominato dall’azienda per cui lei opera, al fine di prendere in carico la segnalazione, gestirla e produrre la relativa reportistica. Per ogni ulteriore informazione contatti l’azienda per cui opera.
           </h1></div>
            <br/> <br/>
            <br/> <br/>
         </div>
        
      ); 
   } 
}